
const Language = new Map();

export const setValue = function (type, value) {
    Language.set(type, value);
}

export const getValue = function(type) {
    const value = Language.get(type) || {};
    return value;
}

